module.exports = __webpack_public_path__ + "static/media/arrow_blue.9efa3da7.svg";